export const CHANGE_RESULT_KEY = 'ANDES/change_result_key';
export const GET_RESULT_LIST = 'ANDES/get_result_list';